import DateFormat from "../common/dateFormat/DateFormat";

const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaStatus: [{
		id: 'Aguardando',
		valor: 'Aguardando'
	}, {
		id: 'Confirmado',
		valor: 'Confirmado'
	}, {
		id: 'Negado',
		valor: 'Negado'
	}],
	filtro: {
		dataInicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(30)),
		dataFinal: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()),
		status: 'Aguardando'
	}
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case 'VOUCHER_MODO_TELA':
			return {
				...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'VOUCHER_LISTADO':
			return {
				...state,
				modoTela: 'lista',
				lista: action.payload.data
			};

		case 'VOUCHER_SET_AGUARDANDO':
			return {
				...state,
				aguardando: action.payload
			};

		case 'VOUCHER_FILTRO':
			return { ...state, filtro: action.payload };

		default:
			return state;
	}
}